import {
  CreateLabelRequest,
  EditLabelRequest,
  Label,
} from '@aibees/elephant/types/label';
import { ErrorResponse } from '@aibees/shared/definition';
import { UseMutationResult } from '@tanstack/react-query';

export const useLabelApiType = (
  addApi: UseMutationResult<Label, ErrorResponse, CreateLabelRequest, any>,
  editApi: UseMutationResult<Label, ErrorResponse, EditLabelRequest, any>,
  isEdit?: boolean
) => {
  return isEdit ? editApi : addApi;
};
